<template>
    <div class="input" :class="{
        'is-disabled': disabled
    }" ref="input" @click="handleClick">
        <textarea 
            class="input-value textarea" 
            ref="inputValue"
            v-bind="$attrs" 
            :disabled="inputDisabled" 
            :readonly="readonly" 
            @input="handleInput"
            @change="handleChange"
            @blur="handleBlur"
            @focus="handleFocus"
            v-if="type == 'textarea'"></textarea>
        <input 
            class="input-value" 
            ref="inputValue" 
            v-bind="$attrs"
            :type="inputType"
            :disabled="inputDisabled" 
            :readonly="readonly" 
            @input="handleInput"
            @change="handleChange"
            @blur="handleBlur"
            @focus="handleFocus"
            v-else />
    </div>
</template>
<script>
export default {
    name:"Input",
    props:{
        type: String,
        value: [String,Number],
        focus: Boolean,
        disabled: Boolean,
        readonly: Boolean,
        showPassword: Boolean,
        integer: Boolean
    },
    inheritAttrs: false,
    data(){
        return {
            inputValue: ''
        }
    },
    mounted(){
        this.setInputValue(this.value);
        if(this.focus){
            this.setFocus();
        }
    },
    computed:{
        inputType(){
            if(this.type == 'password' && this.showPassword) return 'text';
            return this.type;
        },
        inputDisabled(){
            return this.disabled;
        }
    },
    watch:{
        focus(){
            this.setFocus();
        },
        value(newValue){
            this.setInputValue(newValue);
        }
    },
    methods:{
        setFocus(){
            this.getInput().focus();
        },
        getInput(){
            return this.$refs.inputValue
        },
        setInputValue(value = ''){
            let input = this.getInput();
            if(value === input.value) return;
            if(this.type == 'number' && this.integer && value){
                value = parseInt(value);
            }
            input.value = value;
        },
        handleInput(event){
            let value = event.target.value || '';
            this.$emit('input', this.setNumberValue(value));
        },
        handleChange(event){
            let value = event.target.value || '';
            this.$emit('change', this.setNumberValue(value));
        },
        handleBlur(event){
            this.$emit('blur', event);
        },
        handleFocus(event){
            this.$emit('focus', event);
        },
        setNumberValue(value){
            if(this.type == 'number' && value){
                value = +value;
                if(this.integer){
                    value = parseInt(value);
                }
                if(isNaN(value)){
                    value = '';
                }
            }
            return value;
        },
        handleClick(e){
            if(this.inputDisabled) return;
            this.$emit('click', e);
        }
    }
}
</script>
<style lang="scss" scoped>
.input{
    width: 100%;
    &.is-disabled .input-value{
        color: #BFC1C5;
    }
    .input-value{
        width: 100%;
        height: 88px;
        padding-left: 36px;
        box-sizing: border-box;
        background: #F9F9F9;
        border-radius: 8px;
        font-size: 32px;
        font-weight: 400;
        &.textarea{
			height: 156px;
			padding:22px 36px;
			line-height: 44px;
            resize: none;
        }
    }
}
</style>